import { Spin } from 'antd';

/** Pantalla de carga a viewport completo (mientras se restaura la sesión). */
export function FullPageLoader({ tip = 'Cargando…' }: { tip?: string }) {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        background: 'var(--ge-color-bg)',
      }}
    >
      <Spin size="large" tip={tip}>
        <div style={{ padding: 32 }} />
      </Spin>
    </div>
  );
}
